<template>
  <BaseModal ref="BaseModal" @confirm="confirm" @close="close">
    <div v-if="options.type" class="modal-input">
      <el-checkbox v-if="options.type === 'checkbox'" v-model="input" />
      <el-date-picker
        v-else-if="options.type === 'date'"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="请选择日期"
        v-model="input"
      />
      <el-input-number
        v-else-if="options.type === 'number'"
        :precision="options.scale === undefined ? 2 : options.scale"
        placeholder="请输入"
        :controls="false"
        v-model="input"
        style="width: 100%; text-align: left"
      />
      <el-input v-else placeholder="请输入" v-model="input" />
    </div>

    <div class="vtable" v-if="options.columns">
      <VTable
        :showIndex="options.showIndex"
        :allowMultiSelect="options.allowMultiSelect || false"
        ref="vtableRef"
        :columns="options.columns || []"
        :contextMenuMap="contextMenuMap"
        :data="tableData"
        @row-select="handleRowSelect"
      />
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from '../BaseModal/index.vue'
import VTable from '@/components/VTable/index.vue'
import { filterTable } from '@/utils/index'

export default {
  name: 'SelectModal',
  components: { BaseModal, VTable },
  data() {
    return {
      options: {},
      tableData: [],
      contextMenuMap: { 查询: () => this.handleSearch() },
      input: null
    }
  },
  methods: {
    // 显示弹窗
    async show(options = {}) {
      this.options = { ...options }
      this.$refs.BaseModal.show(
        JSON.parse(
          JSON.stringify({
            showConfirm: !!this.options.confirm,
            title: this.options.title,
            width: options.width
          })
        )
      )
      if (this.options.options) {
        this.tableData = JSON.parse(JSON.stringify(this.options.options))
      }
    },
    handleRowSelect(rows) {
      this.input = rows[0][0].dataValue
    },
    handleSearch() {
      this.$filterFieldModal({
        columns: this.options.columns,
        confirm: arr => {
          const filterForm = {}
          arr.forEach(item => (filterForm[item.key] = item.value || undefined))
          this.$refs.vtableRef.tableInstance.updateFilterRules([
            {
              filterFunc(record) {
                return filterTable(record, filterForm)
              }
            }
          ])
        }
      })
    },
    async confirm(close) {
      let res
      if (this.options.type) {
        res = this.input
      } else if (this.options.columns) {
        res = this.$refs.vtableRef.tableInstance.getSelectedCellInfos()
      }
      await this.options.confirm(res, this.tableData)
      close()
    },
    close() {}
  }
}
</script>

<style scoped lang="less">
.vtable {
  width: 100%;
  height: 300px;
}
.modal-input {
  margin-bottom: 12px;
}
::v-deep .el-input-number input {
  text-align: left;
}
</style>
